<template>
  <section>
    <el-row style="padding: 20px">
      <el-col :span="24" style="background: #f5f7fa; margin-bottom: 20px">
        <el-form
          ref="searchForm"
          inline
          class="form-search inputStyle"
          style="margin-top: 24px; padding-left: 20px"
          :model="searchForm"
          :rules="searchFormRules"
          label-width="110px"
        >
          <el-form-item label="商品编号" prop="goodsOrderNo">
            <el-input v-model.trim="searchForm.goodsOrderNo" placeholder="输入商品编号" clearable />
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model.trim="searchForm.goodsName" placeholder="输入商品名称" clearable />
          </el-form-item>
          <el-form-item label="审核状态" prop="checkStatus">
            <el-select v-model="searchForm.checkStatus" placeholder="请选择审核状态" clearable>
              <el-option v-for="item in checkStatus" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期" prop="createTime">
            <el-date-picker
              v-model="searchForm.createTime"
              style="width: 270px"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels
              range-separator="~"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            />
          </el-form-item>
          <br />
          <el-form-item label="操作" class="operateStyle">
            <el-button type="primary" size="medium" style="margin-right: 12px" :loading="listLoading" @click="queryData()">查询</el-button>
            <el-button type="primary" size="medium" style="margin-right: 12px" @click="openEditGoods('add')">添加</el-button>
            <el-button size="medium" @click="clearUp()">重置</el-button>
            
            <el-button type="primary" size="medium" style="margin-right: 12px" @click="openImportGoods">导入</el-button>
            <el-button type="primary" size="medium" :loading="exportLoading" style="margin-right: 12px" @click="exportFun">导出</el-button>
            <el-button type="primary" size="medium" style="margin-right: 12px" icon="el-icon-download" :loading="templateLoading" @click="templateDownload"
              >下载模板</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>

      <!-- 列表渲染开始 -->
      <div style="margin-top: 10px">
        <el-table
          v-loading="listLoading"
          stripe
          max-height="800"
          class="common-list"
          :data="tableData"
          border
          row-key="id"
          element-loading-text="数据加载中，请稍等"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" />
          <el-table-column label="序号" type="index" align="center" width="50px" />
          <el-table-column prop="createTime" label="创建日期" align="center" width="200px" />
          <el-table-column prop="goodsOrderNo" label="商品编号" align="center" width="160px"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称" align="center" width="180px" />
          <el-table-column prop="ruleType" label="规格型号" align="center" width="160px" />
          <el-table-column prop="goodsNum" label="数量" align="center" width="100px" />
          <el-table-column prop="lowPrice" label="单价(低)" align="center" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.lowPrice | parseAmtF2YABS }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="hightPrice" label="单价(高)" align="center" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.hightPrice | parseAmtF2YABS }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="币制" align="center" width="120px" />
          <el-table-column prop="countryOfOrigin" label="原产国(地区)" align="center" width="180px"></el-table-column>
          <el-table-column prop="goodsNetWork" label="商品销售网址/店铺" align="center" width="200px" />
          <el-table-column prop="email" label="联系人电子邮箱" align="center" width="200px" />
          <el-table-column prop="phone" label="联系人电话" align="center" width="200px" />
          <el-table-column prop="addSource" label="加入来源" align="center" width="120px">
            <template slot-scope="scope">
              <span>{{ getAddSourceText(scope.row.addSource) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="checkStatus" label="审核状态" align="center" width="120px">
            <template slot-scope="scope">
              <span>{{ getCheckStatusText(scope.row.checkStatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" />

          <el-table-column label="操作" fixed="right" align="center" width="200px">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.checkStatus !== '03'" @click="openEditGoods('update', scope.row)">修改</el-button>
              <el-button type="text" v-if="scope.row.checkStatus === '01'" @click="showEnableDialog('删除', scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页工具条-->
      <pagination v-show="total > 0" :total="total" :page.sync="page" :limit.sync="size" :current-page="page" @pagination="getDataByPage()" />
    </el-row>

    <!-- 添加或修改商品名录 -->
    <add-goods ref="addGoods" @success="getDataByPage" />

    <!-- 商品导入 -->
    <import-goods ref="importGoods" @success="getDataByPage" />


    <!-- 启用停用对话框 -->
    <el-dialog :title="enableType" :visible.sync="enableDialogVisible" width="40%" :close-on-click-modal="false">
      <el-form ref="enableForm" inline class="form-search inputStyle" :model="enableForm" :rules="enableFormRules" label-width="110px">
        <el-form-item label="备注" prop="remark">
          <el-input v-model.trim="enableForm.remark" style="width: 360px" placeholder="请填写备注" type="textarea" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="enableDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="enableLoading" @click="submitEnable">确定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { queryGoods, deleteGoods, exportGoods, goodsTemplate } from '@/api/crossborder/collection/abroadCollection'
import Pagination from '@/components/Pagination/index' // 分页
import AddGoods from './addGoods'
import ImportGoods from './importGoods'
import { setNull2, getToday } from '@/utils/common' // 工具类
import File from '@/utils/file'

export default {
  components: {
    Pagination,
    AddGoods,
    ImportGoods,
  },
  data: () => ({
    searchForm: {
      goodsOrderNo: null,
      goodsName: null,
      checkStatus: null,
      createTime: null,
      goodsStatus: null,
    },
    listLoading: false,
    page: 1,
    size: 50,
    total: 0,
    tableData: [],
    searchFormRules: {},

    templateLoading: false,

    // 01新增待审核，02修改待审核，03审核通过，04审核驳回
    checkStatus: [
      { value: '01', label: '新增待审核' },
      { value: '02', label: '修改待审核' },
      { value: '03', label: '审核通过' },
      { value: '04', label: '审核驳回' },
    ],

    // 加入来源
    addSources: [
      { value: '01', label: '商户上报' },
      { value: '02', label: '内部风控' },
      { value: '03', label: '行业共享' },
      { value: '04', label: '其他' },
    ],

    // 导出
    exportLoading: false,
    tableSelected: [], // 有效的数据


    // 启用、停用 删除也是用的这个对话框
    enableDialogVisible: false,
    enableType: null,
    enableRow: null, // 用于存放单条启用停用的行
    enableForm: {
      remark: null,
    },
    enableFormRules: {
      remark: [{ required: true, message: '请填写备注', trigger: 'change' }],
    },
    enableLoading: false,
  }),

  created() {
    this.searchForm.createTime = [getToday() + ' 00:00:00', getToday() + ' 23:59:59']
  },

  methods: {
    getAddSourceText(code) {
      let res = ''
      this.addSources.forEach((item) => {
        if (item.value === code) res = item.label
      })
      return res
    },

    getCheckStatusText(code) {
      let res = ''
      this.checkStatus.forEach((item) => {
        if (item.value === code) res = item.label
      })
      return res
    },

    // 查询
    queryData() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.page = 1
          this.getDataByPage()
        }
      })
    },
    // 分页查询
    getDataByPage() {
      this.tableData = []
      const param = setNull2({
        page: this.page ? this.page : 1,
        size: this.size ? this.size : 10,
        param: {
          ...this.searchForm,
          startTime: this.searchForm.createTime ? this.searchForm.createTime[0] : null,
          endTime: this.searchForm.createTime ? this.searchForm.createTime[1] : null,
          merNo: this.$store.getters.merNo,
          merName: this.$store.getters.merName,
          platformType: '02',
          searchType: '01',
        },
      })
      this.listLoading = true
      queryGoods(param)
        .then((res) => {
          this.listLoading = false
          this.total = res.data.total
          if (res.data.list) this.tableData = res.data.list
        })
        .catch((error) => {
          this.listLoading = false
          console.log(error) // 请求失败返回的数据
        })
    },

    // 添加或修改商品
    openEditGoods(type, row) {
      this.$refs.addGoods.open(type, row)
    },

    // 导入
    openImportGoods() {
      this.$refs.importGoods.open()
    },

    templateDownload() {
      this.templateLoading = true
      goodsTemplate({ platformType: '02' })
        .then((res) => {
          this.templateLoading = false
          File.output(res)
        })
        .catch((err) => {
          this.templateLoading = false
          console.error(err)
        })
    },

    handleSelectionChange(val) {
      this.tableSelected = val
    },

    // 导出
    exportFun() {
      let exportType = this.tableSelected.length === 0 ? '01':'02'

      let goodsOrderNoList = []
      this.tableSelected.forEach(item=>{
        goodsOrderNoList.push(item.goodsOrderNo)
      })

      let param = setNull2({
        ...this.searchForm,
        startTime: this.searchForm.createTime ? this.searchForm.createTime[0] : null,
        endTime: this.searchForm.createTime ? this.searchForm.createTime[1] : null,
        merNo: this.$store.getters.merNo,
        merName: this.$store.getters.merName,
        platformType: '02',
        exportType,
        searchType: '01',
        goodsOrderNoList,
      })

      this.exportLoading = true
      exportGoods(param)
        .then((res) => {
          this.exportLoading = false
          File.output(res)
        })
        .catch((err) => {
          this.exportLoading = false
          console.log('导出出错', err)
        })
    },


    // 单条删除
    showEnableDialog(type, row) {
      this.enableDialogVisible = true
      this.enableType = type
      this.enableRow = row
      this.enableForm.remark = null
      this.enableLoading = false
      this.$nextTick(() => {
        this.$refs.enableForm.clearValidate()
      })
    },

    submitEnable() {
      this.$refs.enableForm.validate((valid) => {
        if (valid) {
          if (this.enableType === '删除') {
            this.enableLoading = true
            deleteGoods({
              ...this.enableRow,
              platformType: '02',
              operator: this.$store.getters.merName,
              remark: this.enableForm.remark,
            })
              .then(() => {
                this.enableLoading = false
                this.enableDialogVisible = false
                this.$message.success('删除成功')
                this.getDataByPage()
              })
              .catch((err) => {
                this.enableLoading = false
                console.log('删除失败', err)
              })
          }
        }
      })
    },


    clearUp() {
      this.$refs.searchForm.resetFields()
      this.searchForm.createTime = [getToday() + ' 00:00:00', getToday() + ' 23:59:59']
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/common.scss';
::v-deep .inputStyle .el-form-item__content {
  width: 270px;
}
::v-deep .operateStyle .el-form-item__content {
  width: 660px;
}
</style>
